<div class="entity-up" [class.entity-up--removed]="catalog().isRemoved">
  @if (catalog().articleCount.updated?.new) {
    <span class="entity-up__item entity-up__item--new">
      <span class="entity-up__count">+{{ catalog().articleCount.updated?.new }}</span>
      <span class="entity-up__label">neu</span>
    </span>
  }

  @if (catalog().articleCount.updated?.changed) {
    <span class="entity-up__item entity-up__item--mod">
      <span class="entity-up__count">{{ catalog().articleCount.updated?.changed }}</span>
      <span class="entity-up__label">geändert</span>
    </span>
  }

  @if (catalog().articleCount.updated?.deleted) {
    <span class="entity-up__item entity-up__item--del">
      <span class="entity-up__count">-{{ catalog().articleCount.updated?.deleted }}</span>
      <span class="entity-up__label">gelöscht</span>
    </span>
  }

  <span class="entity-up__item entity-up__item--covin">
    <mp-catalog-covin-badge
      class="catalog-covin-badge"
      [value]="catalog().updatedCovinRate"
      [hideLabel]="true"
      [currentValue]="catalog().currentCovinRate"
    />
  </span>

  <span class="entity-up__spacer"></span>

  @if (allowWrite()) {
    <span class="entity-up__action">
      <mp-update-button
        [value]="catalog().reservedPublish || false"
        [disabled]="catalog().isRemoved"
        (toggled)="emitIndustryCatalogUpdate(catalog(), $event)"
      />
    </span>
  }
</div>
